export default __webpack_public_path__ + "static/media/password.d7df9588.svg";